import { render, staticRenderFns } from "./SolicitacoesRegaste.vue?vue&type=template&id=08795148&scoped=true"
import script from "./SolicitacoesRegaste.vue?vue&type=script&lang=js"
export * from "./SolicitacoesRegaste.vue?vue&type=script&lang=js"
import style0 from "./SolicitacoesRegaste.vue?vue&type=style&index=0&id=08795148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08795148",
  null
  
)

export default component.exports